import { InputLabel, MenuItem, Select } from "@material-ui/core";
import React from "react";
var IndustrySelect = function (props) {
    return React.createElement("div", { className: "col s12 m6" },
        React.createElement(InputLabel, null, "Industry"),
        React.createElement(Select, { className: "select", placeholder: "Industry", name: "industry", onChange: props.onChange, value: props.value, readOnly: props.readonly, disabled: props.readonly },
            React.createElement(MenuItem, { value: "Bar" }, "Bar"),
            React.createElement(MenuItem, { value: "Brewery" }, "Brewery"),
            React.createElement(MenuItem, { value: "Cafe" }, "Caf\u00E9"),
            React.createElement(MenuItem, { value: "Construction" }, "Construction"),
            React.createElement(MenuItem, { value: "Fitness" }, "Fitness"),
            React.createElement(MenuItem, { value: "Hair Dresser" }, "Hair Dresser"),
            React.createElement(MenuItem, { value: "Hotel" }, "Hotel"),
            React.createElement(MenuItem, { value: "Jeweler" }, "Jeweler"),
            React.createElement(MenuItem, { value: "Laywer" }, "Lawyer"),
            React.createElement(MenuItem, { value: "Marketing" }, "Marketing"),
            React.createElement(MenuItem, { value: "Medical" }, "Medical"),
            React.createElement(MenuItem, { value: "Pharmacy" }, "Pharmacy"),
            React.createElement(MenuItem, { value: "Restaurant" }, "Restaurant"),
            React.createElement(MenuItem, { value: "Retail" }, "Retail"),
            React.createElement(MenuItem, { value: "Service Provider" }, "Service Provider"),
            React.createElement(MenuItem, { value: "Takeaway" }, "Takeaway"),
            React.createElement(MenuItem, { value: "Tech" }, "Tech")));
};
export default IndustrySelect;



//////////////////
// WEBPACK FOOTER
// ./src/components/common/IndustrySelect.tsx
// module id = 292
// module chunks = 0